'use strict';

module.exports = require('./_util');
